import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { QUERY_NAME, SERVICES, TEXT_SCALE_PROPS } from "@lhd/constants";
import axios from "@lhd/libs/axios";
import { getAccessToken, getClient, getUid } from "@lhd/utility";

export const useFetchSettingSize = (enabledOverride = true) => {
  const uid = getUid();
  const accessToken = getAccessToken();
  const client = getClient();

  return useQuery<TEXT_SCALE_PROPS>(
    [QUERY_NAME.USER_INTERFACE_SETTINGS],
    () =>
      axios
        .get(SERVICES.USER_INTERFACE_SETTINGS, {
          params: {
            uid,
            client,
            "access-token": accessToken,
          },
        })
        .then((res) => res.data),
    {
      cacheTime: 5000,
      staleTime: 5000,
      retry: 2,
      enabled: !!accessToken && enabledOverride,
    },
  );
};

export const usePutSettingSize = () => {
  const queryClient = useQueryClient();
  const uid = getUid();
  const accessToken = getAccessToken();
  const client = getClient();

  return useMutation(
    (text_scale: string) =>
      axios({
        method: "put",
        url: SERVICES.USER_INTERFACE_SETTINGS,
        data: {
          uid,
          client,
          text_scale,
          "access-token": accessToken,
        },
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),
    {
      onSuccess() {
        queryClient.invalidateQueries([QUERY_NAME.USER_INTERFACE_SETTINGS]);
      },
    },
  );
};
